import { ItemTypes } from '@citypantry/util-models';
import { AnalyticsActions } from '../analytics-action.enum';
import { AnalyticsCategories } from '../analytics-category.enum';
import { AnalyticsRule } from './analytics-rule.interface';

export const customItemFormPageRules: AnalyticsRule[] = [
  {
    url: '/menus/builder/custom-items/:id',
    path: 'custom-item-editor-sidebar save-item-and-return',
    events: 'click',
    definition: ((event) => ({
      category: AnalyticsCategories.ITEM_EDITOR,
      action: AnalyticsActions.CLICK,
      label: 'Item save and return clicked',
      extraFields: {
        itemType: ItemTypes.CUSTOM_ITEM,
        itemId: event.data['custom-item-editor-sidebar'].itemId,
        isItemComplete: event.data['custom-item-editor-sidebar'].isItemComplete,
      },
    })),
  },
  {
    url: '/menus/builder/custom-items/:id',
    path: 'custom-item-editor-sidebar save-item',
    events: 'click',
    definition: ((event) => ({
      category: AnalyticsCategories.ITEM_EDITOR,
      action: AnalyticsActions.CLICK,
      label: 'Item save clicked',
      extraFields: {
        itemType: ItemTypes.CUSTOM_ITEM,
        itemId: event.data['custom-item-editor-sidebar'].itemId,
        isItemComplete: event.data['custom-item-editor-sidebar'].isItemComplete,
      },
    })),
  },
];
